import React, { useState } from "react";
import { Modal } from "antd";
import { exportDocument } from "../../../../../helpers/Utils";
import { IconSearch } from "../../../../../components/Layout/Icons";

const ImageWithPreviewModal = ({
  asset,
  created_at,
  id,
  width = 45,
  height = 90,
}) => {
  const [previewImage, setPreviewImage] = useState(false);

  return (
    <div
      className="position-relative"
      onClick={() => setPreviewImage(!previewImage)}
      style={{ width, height, marginBottom: 5 }}
    >
      <div
        style={{
          backgroundImage: `url(${asset.url})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          height: "100%",
        }}
      />

      <div
        className="position-absolute d-flex align-items-center justify-content-center cursor-pointer"
        style={{
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          background: "rgba(255, 255, 255, 0.9)",
          border: "1px solid #E0E0E0",
          borderRadius: 32,
          width: 30,
          height: 30,
        }}
      >
        <IconSearch color="#777777" />
      </div>
      {previewImage && (
        <Modal
          title={asset?.url?.split("/")?.at(-1) ?? "Something wrong"}
          visible={previewImage}
          okText="Download"
          onOk={() => {
            exportDocument(
              `/api/v1/energy_documents/${id}/download`,
              asset?.url?.split("/")?.at(-1),
              "POST"
            );
          }}
          onCancel={() => setPreviewImage(false)}
          width={1000}
          cancelText="Close"
        >
          <div className="d-flex justify-content-between">
            <div className="d-flex justify-content-center" style={{ flex: 4 }}>
              <img className="img-fluid" src={asset.url} />
            </div>

            <div className="pl-2" style={{ flex: 1 }}>
              <ul>
                <li>
                  <span className="font-weight-bold">Title: </span>
                  {asset?.url?.split("/")?.at(-1) ?? "Something wrong"}
                </li>
                <hr />
                <li>
                  <span className="font-weight-bold">Format: </span>
                  {asset?.url?.split(".")?.at(-1) ?? "Something wrong"}
                </li>
                <hr />
                <li>
                  <span className="font-weight-bold">Uploaded document: </span>
                  {created_at.substr(0, 10)}
                </li>
              </ul>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ImageWithPreviewModal;
